import React from 'react';
import { PrismicRichText } from '@prismicio/react';
import * as prismic from '@prismicio/client';

/**
 * Simple Heading component for demonstration. Replace it with your actual Heading component.
 */
export const linkResolver = (data) => {
  if (data.link_type === 'Web') {
    return data.url;
  }
  if (data.link_type === 'Document') {
    return `/${data.uid}`;
  }
  return '/';
};
const component = {
  heading1: ({ children }) => <h1>{children}</h1>,
  heading2: ({ children }) => <h2>{children}</h2>,
  heading3: ({ children }) => <h3>{children}</h3>,
  heading4: ({ children }) => <h4>{children}</h4>,
  heading5: ({ children }) => <h5>{children}</h5>,
  heading6: ({ children }) => <h6>{children}</h6>,
  paragraph: ({ children }) => <p>{children}</p>,
  preformatted: ({ node }) => <pre>{JSON.stringify(node.text)}</pre>,
  strong: ({ children }) => <strong>{children}</strong>,
  em: ({ children }) => <em>{children}</em>,
  listItem: ({ children }) => (
    <li style={{ listStyleType: 'inherit', marginLeft: '32px' }}>{children}</li>
  ),
  oListItem: ({ children }) => (
    <li style={{ listStyleType: 'inherit', marginLeft: '32px' }}>{children}</li>
  ),
  list: ({ children }) => <ul>{children}</ul>,
  oList: ({ children }) => <ol>{children}</ol>,
  image: ({ node }) => {
    const linkUrl = node.linkTo ? linkResolver(node.linkTo) : null;
    const linkTarget =
      node.linkTo && node.linkTo.target
        ? `target="${node.linkTo.target}" rel="noopener"`
        : '';
    const wrapperClassList = [node.label || '', 'block-img'];
    return (
      <p className={wrapperClassList.join(' ')}>
        {linkUrl ? (
          <a {...{ href: linkUrl, ...linkTarget }}>
            <img
              src={node.url}
              alt={node.alt || ''}
              copyright={node.copyright || ''}
            />
          </a>
        ) : (
          <img
            src={node.url}
            alt={node.alt || ''}
            copyright={node.copyright || ''}
          />
        )}
      </p>
    );
  },
  embed: ({ node }) => (
    <div
      data-oembed={node.oembed.embed_url}
      data-oembed-type={node.oembed.type}
      data-oembed-provider={node.oembed.provider_name}
      {...label(node)}
    >
      {node.oembed.html}
    </div>
  ),
  hyperlink: ({ node, children }) => {
    const target = node.data.target
      ? `target="${node.data.target}" rel="noopener"`
      : '';
    const url = linkResolver(node.data);
    return <a {...{ href: url, target }}>{children}</a>;
  },

  label: ({ node, children }) => (
    <span className={node.data.label}>{children}</span>
  ),
  span: ({ text }) => (text ? text : ''),
};

/**
 * @typedef {import("@prismicio/client").Content.TextSlice} TextSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<TextSlice>} TextProps
 * @param {TextProps} props
 */
const Text = ({ slice }) => {
  return (
    <section
      style={{
        lineHeight: '1.7',
        listStyleType: 'inherit',
        listStyle: 'inherit',
      }}
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
    >
      {prismic.isFilled.richText(slice.primary.text) && (
        <PrismicRichText field={slice.primary.text} components={component} />
      )}
    </section>
  );
};

export default Text;
